import React, { Component } from 'react';
import {
  Container,
  Card,
  Row,
  Col,
  Button,
  Spinner,
  InputGroup,
  Form,
  Table,
  Badge,
  ButtonGroup,
  DropdownButton,
  Dropdown,
} from 'react-bootstrap';
import { t } from '../../helpers/translation_helper';
import NavBar from '../_partials/NavBar/_NavBar';
import Header from '../_partials/Header/_Header';
import { connect } from 'react-redux';
import { brand_colors } from '../../helpers/brand_colors_helper';
import {
  faBell,
  faBellConcierge,
  faCalendar,
  faConciergeBell,
  faDumbbell,
  faEye,
  faEyeSlash,
  faNoteSticky,
  faSearch,
  faWarning,
  faXmark,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { DateRangePicker } from 'react-date-range';
import moment from 'moment';
import { GET } from '../../api';
import { numberFormat } from '../../helpers/general_helpers';
import {
  faCalendarAlt,
  faFileExcel,
} from '@fortawesome/free-regular-svg-icons';
import * as FileSaver from 'file-saver';
import XLSX from 'sheetjs-style';
import { renderTableBody, renderTableHead } from '../../helpers/table_helper';
import Pagination from '../_partials/Pagination';
import Select from 'react-select';
import { toast } from 'react-toastify';
import Flatpickr from 'react-flatpickr';
import SweetAlert from 'react-bootstrap-sweetalert';
let cancelToken;

class EmployeeSalaryHistory extends Component {
  state = {
    fetching: false,
    employeeSalaries: [],
  };

  componentDidMount() {
    this.fetch();
  }

  fetch = async (params) => {
    this.setState({
      fetching: true,
    });

    if (this.fetchReq) {
      this.fetchReq.abort();
    }
    this.fetchReq = new AbortController();

    try {
      const res = await GET('employee-salary-history/get', {
        signal: this.fetchReq.signal,
      });
      this.setState({
        employeeSalaries: res.data,
      });

      console.log('res', res);
    } catch (err) {
      this.setState({
        fetching: false,
      });
    }
  };

  exportExcel = async () => {
    const excelData = [];

    for (let i = 0; i < this.state.employeeSalaries.length; i++) {
      for (let j = 0; j < this.state.employeeSalaries[i].salary_history.length; j++) {
        const salary = this.state.employeeSalaries[i].salary_history[j];
        const employee = this.state.employeeSalaries[i].employee;

        excelData.push({
          'Employee Name': employee.employee_name,
          'Joining Date': moment(employee.joining_date).format('DD-MM-YYYY'),
          Date: moment(salary.created_date).format('DD-MM-YYYY'),
          'Basic Salary': parseFloat(salary.salary),
          'Housing Allowance': parseFloat(salary.housing_allowance),
          'Transportation Allowance': parseFloat(salary.transportation_allowance),
          'Other Allowance': parseFloat(salary.other_allowance),
          'Total Salary':
            parseFloat(salary.salary) +
            parseFloat(salary.housing_allowance) +
            parseFloat(salary.transportation_allowance) +
            parseFloat(salary.other_allowance),
          Status: salary.status == 1 ? 'Active' : 'Not Active',
        });
      }

    }

    const fileName = 'Employee Salary History ' + moment().format('DD-MM-YYYY');
    const fileType =
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const fileExtension = '.xlsx';
    const ws = XLSX.utils.json_to_sheet(excelData);

    const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const data = new Blob([excelBuffer], { type: fileType });

    FileSaver.saveAs(data, fileName + fileExtension);
  };

  render() {

    console.log('%cSTATE', 'color: orange; font-size: 25px; font-weight: bold', this.state);

    return (
      <Container fluid>
        <div id='iedu-layout'>
          <NavBar />
          <div id='page-content'>
            <Header
              lite={true}
              heading={t('Employee Salary History')}
              backBtn={true}
            />
            <Card className='border-0' style={{ borderRadius: '20px' }}>
              <Card.Header
                style={{
                  backgroundColor: '#fff',
                  borderTopLeftRadius: '20px',
                  borderTopRightRadius: '20px',
                }}>
                <Row>
                  <Col md={6} className='d-flex align-items-center'>
                    <ButtonGroup size='sm' className='me-3 float-left'>
                      <Button onClick={() => this.exportExcel()}>
                        <FontAwesomeIcon icon={faFileExcel} /> {t('Export Excel')}
                      </Button>
                    </ButtonGroup>
                  </Col>
                </Row>
              </Card.Header>
              <Card.Body style={{ paddingTop: 8 }}>
                <Table>
                  <tbody>
                    {this.state.employeeSalaries.map((item, index) => (
                      <>
                        <tr>
                          <th style={{ background: '#e3e3e3' }} colSpan={3}>
                            {t('Employee Name')}
                            <span style={{ fontWeight: 'normal', paddingLeft: 10 }}>{item.employee.employee_name}</span>
                          </th>
                          <th style={{ background: '#e3e3e3' }} colSpan={4}>
                            {t('Joining Date')}
                            <span style={{ fontWeight: 'normal', paddingLeft: 10 }}>{moment(item.employee.joining_date).format('DD-MM-YYYY')}</span>
                          </th>
                        </tr>
                        <tr>
                          <th style={{ background: '#f2f2f2' }}>{t('Date')}</th>
                          <th style={{ background: '#f2f2f2' }}>{t('Basic Salary')}</th>
                          <th style={{ background: '#f2f2f2' }}>{t('Housing Allowance')}</th>
                          <th style={{ background: '#f2f2f2' }}>{t('Transportation Allowance')}</th>
                          <th style={{ background: '#f2f2f2' }}>{t('Other Allowance')}</th>
                          <th style={{ background: '#f2f2f2' }}>{t('Total Salary')}</th>
                          <th style={{ background: '#f2f2f2' }}>{t('Status')}</th>
                        </tr>
                        {item.salary_history.map((salary, salary_index) => (
                          <tr key={salary_index}>
                            <td>{moment(salary.created_date).format('DD-MM-YYYY')}</td>
                            <td>{parseFloat(salary.salary)}</td>
                            <td>{parseFloat(salary.housing_allowance)}</td>
                            <td>{parseFloat(salary.transportation_allowance)}</td>
                            <td>{parseFloat(salary.other_allowance)}</td>
                            <td>{parseFloat(salary.salary) + parseFloat(salary.housing_allowance) + parseFloat(salary.transportation_allowance) + parseFloat(salary.other_allowance)}</td>
                            <td>
                              {salary.status == 1 ? (
                                <Badge bg='success'>{t('Active')}</Badge>
                              ) : (
                                <Badge bg='danger'>{t('Not Active')}</Badge>
                              )}
                            </td>
                          </tr>
                        ))}
                      </>
                    ))}
                  </tbody>
                </Table>
              </Card.Body>
            </Card>
          </div>
        </div>
      </Container>
    );
  }
}

const mapStateToProps = (state) => ({
  authData: state.auth.authData,
  selectedClass: state.selectedClass.data,
  defaultLanguage: state.language.defaultLanguage,
  defaultTheme: state.theme.defaultTheme,
});

export default connect(mapStateToProps, null)(EmployeeSalaryHistory);
